import { useTranslation } from 'react-i18next';

import { FullScreenNotice } from './FullScreenNotice';

/**
 * 모든 진단을 마쳤다고 알리는 전체화면 (시안 `893:13968`).
 *
 * 시안은 마스코트 좌우에 축하 이펙트를 둔다(`confetti-left/right.svg`). 지금은 안 쓴다 —
 * 그림 두 장을 더 싣는 일이고, 이 화면이 말하는 바("끝났다")는 제목과 마스코트가 이미
 * 전부 말한다.
 *
 * 시안에는 이 화면의 **분석 중** 변형(`892:13870`)이 하나 더 있다 — CTA 자리에 스피너가
 * 돌고 주석에 "결과 생성까지 약 5초"라 적혀 있다. 그 상태는 **안 만든다**: 지금 결과는
 * `useRecordMachine.finish()`가 프레임을 그 자리에서 분석해 동기로 만들고
 * (서버 `/analyze`는 `RECORD_ENDPOINT`가 비어 있어 안 붙어 있다), 기다릴 것이 없는데
 * 스피너를 돌리면 화면이 없는 일을 하는 척하게 된다. 서버 경로가 붙는 날 그때 만든다.
 */

export const AllDoneView = ({
  onResult,
  onRetry,
}: {
  onResult: () => void;
  onRetry: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <FullScreenNotice
      title={t('web.diagnosis.allDone.title')}
      banner={t('web.diagnosis.allDone.body')}
      footer={
        <div className="flex w-full flex-col gap-3">
          <button
            type="button"
            onClick={onResult}
            className="h-[50px] w-full rounded-full bg-[var(--bk-900)] text-base font-bold tracking-[0.08px] text-white motion-safe:active:scale-95"
          >
            {t('web.diagnosis.allDone.result')}
          </button>
          {/* 시안에 없는 문. 합성 음성 회차처럼 값이 못 미더운 경우의 유일한 출구다. */}
          <button
            type="button"
            onClick={onRetry}
            className="min-h-[44px] w-full text-sm font-semibold text-muted-foreground underline underline-offset-4"
          >
            {t('web.diagnosis.done.retry')}
          </button>
        </div>
      }
    />
  );
};
